import { AdmDataGrid } from "@components/common/data-grid/adm-data-grid";
import { Text, Dropdown } from "@flat-ui";
import { Box } from "@mui-wrapper";
import { testingImpersonationEntries } from "@pages/testing-impersonation/testing-impersonation-data";
import { useTestingImpersonationTableColumns } from "@pages/testing-impersonation/use-testing-impersonation-table-columns";
import { runtimeConfig } from "@src/runtime-config";
import { useState } from "react";

/** Dropdown value representing no numbered environment selection */
const NO_NUMBERED_ENV = "no-numbered";

/** Options listed in the environment dropdown (dev1 to dev20) */
const devEnvironmentOptions = Array.from(
  { length: 20 },
  (_, index) => `dev${index + 1}`
);

/** Page used to test impersonation. Not available on production. */
export function TestingImpersonationPage(): React.JSX.Element {
  const [selectedEnvironment, setSelectedEnvironment] =
    useState(NO_NUMBERED_ENV);
  const numberedEnvironment =
    selectedEnvironment === NO_NUMBERED_ENV ? "" : selectedEnvironment;
  const columns = useTestingImpersonationTableColumns(numberedEnvironment);

  const appEnv = runtimeConfig.appEnv;

  return (
    <Box
      sx={{
        mx: 2.5,
        display: "flex",
        flexDirection: "column",
        height: "calc(100vh - 160px)",
      }}
    >
      <Text variant="heading20">Testing impersonation</Text>

      <AdmDataGrid
        entities={
          testingImpersonationEntries[
            appEnv as keyof typeof testingImpersonationEntries
          ]
        }
        uniqueIdKey="memberId"
        tableType="testing-impersonation-table"
        columns={columns}
        errorMessage=""
        shouldShowErrorMessage={false}
        defaultSortModel={[{ field: "nameAndEmail", sort: "asc" }]}
        additionalToolbarButtons={
          <Box sx={{ display: "flex", alignItems: "center", gap: 2, ml: 3 }}>
            <Dropdown
              placeholder="Select environment"
              value={selectedEnvironment}
              onChange={(event) => setSelectedEnvironment(event.target.value)}
              options={[
                {
                  key: NO_NUMBERED_ENV,
                  value: NO_NUMBERED_ENV,
                  label: "No numbered",
                },
                ...devEnvironmentOptions.map((option) => ({
                  key: option,
                  value: option,
                  label: option,
                })),
              ]}
              sx={{ width: "12rem" }}
            />
          </Box>
        }
      />
    </Box>
  );
}
